module.exports = __webpack_public_path__ + "img/bg.378dea18.svg";